import { Component } from 'opus-angular-seed-core';
import _ from 'lodash';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <div class="form">
            <form-row error="vm.form.errors.isRandomizedQuestionsAssigned">
                <div class="items">
                    <ul class="checkboxes">
                        <li><label><input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.isRandomizedQuestionsAssigned"
                        type="checkbox"> {{ 'formsQuestionsSettings.Assign randomized questions to test' | translate }}</label></li>
                    </ul>
                </div>
            </form-row>
            <form-row error="vm.form.errors.randomizedQuestionsAssignmentType" ng-if="vm.form.model.isRandomizedQuestionsAssigned">
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <label>
                                <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.randomizedQuestionsAssignmentType"
                                type="radio" value="{{ vm.FORMS_RANDOMIZED_TYPE_ENUM.KEYS.TOTAL_AMOUNT }}">
                                <form-row-error></form-row-error>
                                {{ vm.FORMS_RANDOMIZED_TYPE_ENUM.LABELS.TOTAL_AMOUNT }}
                            </label>
                            <label>
                                <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.randomizedQuestionsAssignmentType"
                                type="radio" value="{{ vm.FORMS_RANDOMIZED_TYPE_ENUM.KEYS.CATEGORY }}">
                                {{ vm.FORMS_RANDOMIZED_TYPE_ENUM.LABELS.CATEGORY }}
                            </label>
                        </li>
                    </ul>
                    <form-row error="vm.form.errors.numberOfSelectedRandomQuestions"
                    ng-if="vm.form.model.randomizedQuestionsAssignmentType === vm.FORMS_RANDOMIZED_TYPE_ENUM.KEYS.TOTAL_AMOUNT">
                        <label class="label">{{ 'formsQuestionsSettings.Number of questions selected to test' | translate }} *</label>
                        <div class="items">
                            <input ng-disabled="!vm.canManageForm" type="number"
                            ng-model="vm.form.model.numberOfSelectedRandomQuestions"class="form-control min">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <p ng-if="vm.form.model.randomizedQuestionsAssignmentType === vm.FORMS_RANDOMIZED_TYPE_ENUM.KEYS.CATEGORY">
                    {{ 'formsQuestionsSettings.Total questions assigned to the test' | translate }} {{ assignedQuestions() }}</p>
                    <form-row additional-classes="'row-wide'" error="vm.form.errors.assignedRandomizedQuestionCountPerCategory"
                    ng-if="vm.form.model.randomizedQuestionsAssignmentType === vm.FORMS_RANDOMIZED_TYPE_ENUM.KEYS.CATEGORY">
                        <div class="items">
                            <table class="data03">
                                <tbody>
                                    <form-row-error></form-row-error>
                                    <tr>
                                        <th>{{ 'formsQuestionsSettings.Category name' | translate }}</th>
                                        <th>{{ 'formsQuestionsSettings.Questions in category' | translate }}</th>
                                        <th>{{ 'formsQuestionsSettings.Number of questions' | translate }}</th>
                                    </tr>
                                    <tr ng-repeat="category in vm.categories">
                                        <td>{{ category.name }}</td>
                                        <td>{{ category.total }}</td>
                                        <td class="input">
                                            <input ng-disabled="!vm.canManageForm" class="form-control small" ng-change="vm.calculate()"
                                            ng-model="vm.form.model.assignedRandomizedQuestionCountPerCategory[category.id]" type="text">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                       </div>
                    </form-row>
                </div>
            </form-row>
        </div>
    `
})

export default class {
    constructor ($scope, $state, lodash, FORMS_DISPLAY_TYPE_ENUM, FORMS_RANDOMIZED_TYPE_ENUM, FormService, ListFactory, QuestionResource) {
        this.$scope = $scope;
        this.$state = $state;
        this.lodash = lodash;
        this.FORMS_DISPLAY_TYPE_ENUM = FORMS_DISPLAY_TYPE_ENUM;
        this.FORMS_RANDOMIZED_TYPE_ENUM = FORMS_RANDOMIZED_TYPE_ENUM;
        this.canManageForm = FormService.canManageForm(this.form.model);
        this.ListFactory = ListFactory;
        this.QuestionResource = QuestionResource;
    }

    $onInit () {
        this.initCategories();
        this.initAssignedQuestions();
    }

    initCategories () {
        this.defaultQuery = {
            formId: this.form.model.id,
            expand: 'activeI18n,category'
        };

        const categories = {};
        this.QuestionResource.query(this.defaultQuery).$promise
        .then((response) => {
            this.lodash.forEach(response, (question) => {
                const category = categories[question.categoryId] ? categories[question.categoryId] : {
                    id: question.categoryId,
                    name: question.category ? question.category.name : 'Questions without category',
                    total: 0
                };
                category.total++;
                categories[question.categoryId] = category;
            });
            this.categories = _.values(categories);
        });
    }

    initAssignedQuestions () {
        this.$scope.assignedQuestions = () => {
            let total = 0;
            this.lodash.forEach(this.$scope.$parent.vm.form.model.assignedRandomizedQuestionCountPerCategory, (count) => {
                count = Number(count) || 0;
                total += count;
            });
            this.form.model.numberOfSelectedRandomQuestions = total;
            return total;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/actions/settings/questions/index.js